import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Field } from 'formik';

import RadioButton from 'web/components/form-elements/RadioButton';
import Select from 'web/components/form-elements/Select';
import AddCardPopup from 'web/components/AddCardPopup';
import styled from 'styled-components'
import styles from './payment.module.scss';

import { fetchLanguageContentNew } from "redux/actions/language";

export default ({ checkoutPageData, props, callBackCheckoutFetchApi }) => {
    const dispatch = useDispatch();
    const [cardDetailsList, setCardDetailsList] = useState()
    const [achCardsList, setAchCardsList] = useState()
    const [achBackUpCardDetailsList, setAchBackUpCardDetailsList] = useState()
    const newPaymentArr = [{ value: '0', label: 'Add Payment Details', }]

    const [addCardmodal, setAddCardmodal] = useState(false);
    const addCardToggleModal = () => setAddCardmodal(!addCardmodal);

    const currentLanguage = useSelector((state) => state.language.currentLanguage);
    const languageContentNew = useSelector((state) => state.language.languageContentNew);
    const [pageLanguageContents, setPageLanguageContents] = useState();
    useEffect(() => {
        if (languageContentNew?.H8_Nav_Payment_Page) setPageLanguageContents(languageContentNew.H8_Nav_Payment_Page);
        else dispatch(fetchLanguageContentNew(currentLanguage))
    }, [languageContentNew]);

    useEffect(() => {
        setPaymentDetailsFunc()
    }, [checkoutPageData])

    const setPaymentDetailsFunc = () => {
        const { setFieldValue } = props
        let cardDetailsListTemp = [], achAccountDetailsTemp
        let paymentDetailsTemp = checkoutPageData.paymentMethodDetails || checkoutPageData.paymentDetails
        if (paymentDetailsTemp?.cardDetails?.length > 0) {
            cardDetailsListTemp = paymentDetailsTemp?.cardDetails?.map(data => {
                if (data.defaultPayment) {
                    setFieldValue('cardTypeRadio', data.id)
                    setFieldValue('paymentMethod', data.paymentMethod)
                }
                return (
                    {
                        value: data.id,
                        label: `${data.brandName?.charAt(0).toUpperCase() + data.brandName.slice(1)} ending in ${data.last4Digit}, expires ${data.expMonth}/${data.expYear}`,
                        defaultPayment: data.defaultPayment,
                        type: data.paymentMethod
                    }
                )
            })
            setAchBackUpCardDetailsList([...cardDetailsListTemp])
        }
        if (paymentDetailsTemp?.achDetails?.length > 0) {
            achAccountDetailsTemp = paymentDetailsTemp?.achDetails?.map(data => {
                if (data.defaultPayment) {
                    setFieldValue('cardTypeRadio', data.id)
                    setFieldValue('achSelected', true)
                    setFieldValue('paymentMethod', data.paymentMethod)
                }
                return (
                    {
                        value: data.id,
                        label: 'Account Number: ******' + data.last4Digit + ' Bank Routing Number: ******' + data.routingNumber,
                        type: data.paymentMethod,
                        defaultPayment: data.defaultPayment
                    }
                )
            })
            if (achAccountDetailsTemp) {
                setAchCardsList(achAccountDetailsTemp)
                cardDetailsListTemp.push(achAccountDetailsTemp)
            }
        }
        if (cardDetailsListTemp) setCardDetailsList(cardDetailsListTemp.flat())
    }

    const creditDetailFields = () => {
        return (
            <div>
                <div className={styles.cardDetails}>
                    {cardDetailsList &&
                        cardDetailsList.map((value, index) => (
                            <NewPayment className="row">
                                <div className="col-12">
                                    <div className={styles.field} key={index}>
                                        <Field
                                            component={RadioButton}
                                            name='cardTypeRadio'
                                            className="radio-label"
                                            id={value.value}
                                            // defaultValue={value.defaultPayment}
                                            onSelect={(e) => {
                                                const { setFieldValue } = props
                                                let paymentOptionTemp = cardDetailsList.filter(data => data.value === e.target.value)
                                                if (paymentOptionTemp && paymentOptionTemp?.length > 0) setFieldValue('paymentMethod', paymentOptionTemp[0].type)
                                                if (achCardsList?.filter(val => val.value === e.target.value).length > 0) {
                                                    setFieldValue('achSelected', true)
                                                } else setFieldValue('achSelected', false)
                                            }}
                                            label={value.label}
                                        />
                                    </div>
                                </div>
                            </NewPayment>
                        ))}
                </div>
            </div>
        )
    }
    return (
        <>
            <div className={styles.Wrapper}>
                <div>
                    {cardDetailsList ? creditDetailFields() : (
                        // <div className="row">
                        //     <div className="col-12">
                        //         <p>Add payment details</p>
                        //     </div>
                        // </div> 
                        <></>)}
                </div>
            </div>
            {props.values?.achSelected &&
                // <div style={{ position: 'relative', left: '2px', width: '500px' }}>
                <div className='ach-wrapper'>
                    <p>Select a backup card for ACH*</p>
                    <Select
                        name="achBackUpCard"
                        data={achBackUpCardDetailsList}
                        placeholder='Select a card'
                        onChangeHandler={(data) => { }}
                    />
                </div>
            }
            <div className={styles.checkoutNewPayment}>
                <NewPayment className="row">
                    <div className="col-12">
                        <div className={styles.field}>
                            <Field
                                component={RadioButton}
                                name='cardTypeRadioNew'
                                className="radio-label"
                                id={newPaymentArr[0].value}
                                defaultValue={newPaymentArr[0].value}
                                onSelect={(e) => { addCardToggleModal() }}
                                label={newPaymentArr[0].label}
                                checked={false}
                            />
                        </div>
                    </div>
                </NewPayment>
            </div>

            <AddCardPopup
                isOpen={addCardmodal}
                toggle={addCardToggleModal}
                title=''
                response=''
                individual={(cardDetailsList && cardDetailsList?.length > 0) ? '' : 'Individual'}
                callBackModal={() => {
                    addCardToggleModal();
                }}
                callBackFetchApi={() => {
                    callBackCheckoutFetchApi()
                    addCardToggleModal()
                }}
                onClickHander={(val) => {
                }}
                content=""
                link=''
                pageLanguageContents={pageLanguageContents}
            />
        </>
    );
};


const NewPayment = styled.div`
    > div {
        border-right: none !important;
    }
    .radio-label {
        color: #000 !important;
        margin-bottom: 0;
    }
    .radioField {
        height: 60px !important;
        display: flex;
    align-items: center;
    }
    @media (max-width: 465px){
        margin-top: 8px;
    }
`
